// AppRoutes.jsx
import {Navigate, Route, Routes} from 'react-router-dom';
import Application from "./Application";
import {routes} from "./routes"; // wrapper with <Outlet/>

export default function AppRoutes() {
    return (
        <Routes>
            {/* redirect "/" → "/en/" so Snap has a real entry-point */}
            <Route path="/" element={<Navigate to="/en" replace/>}/>

            {['en', 'de'].map((lang) => (
                <Route
                    key={lang}
                    path={`${lang}`}       //   /en   /de
                    element={<Application lang={lang}/>}
                >
                    {/* home page (routes.home has "") */}
                    <Route
                        index
                        element={<routes.home.element lang={lang}/>}
                    />

                    {/* every other page from routes.js */}
                    {Object.entries(routes).map(([key, cfg]) => {
                        // skip "home", which we handled above
                        if (key === 'home' || !cfg[lang]) return null;

                        const Component = cfg.element;
                        return (
                            <Route
                                key={`${lang}-${key}`}
                                path={cfg[lang]}            // e.g. pricing / preise
                                element={<Component lang={lang}/>}
                            />
                        );
                    })}
                </Route>
            ))}
        </Routes>
    );
}
